import React from "react";

import NumberInput from "@cayuse/shared-react.components.form.inputs.number";

import ErrorInput from "components/ErrorInput";
import { useDictionary } from "hooks/useDictionary";
import { getPersonMonthsError } from "utils/budgetBuilder";


export const PersonMonthsInput = props => {
	const dictionary = useDictionary("budgetBuilder.components.PersonMonthsInput");
	const validatePersonMonths = newPersonMonths => {
		const personMonthsError = getPersonMonthsError(newPersonMonths);

		return personMonthsError ? dictionary?.[personMonthsError] : null;
	};


	return (
		<ErrorInput
			{...props}
			validate={validatePersonMonths}
			renderInput={inputProps => <NumberInput {...inputProps}/>}
		/>
	);
};
